import { Capacitor } from "@capacitor/core";
import { Chooser } from "@ionic-native/chooser";

/**
 * Result from the file chooser.
 */
export interface ChooserResult {
  uri: string;
  name: string;
  mediaType: string;
}

/**
 * Opens a file picker dialog to select a file.
 * On native platforms, opens the native file picker.
 * On web, throws an error as this operation is not supported.
 *
 * @param mimeTypes - Comma-separated list of accepted MIME types
 * @returns The selected file info or undefined if user cancelled
 */
export async function getFile(mimeTypes: string): Promise<ChooserResult | undefined> {
  if (!Capacitor.isNativePlatform()) {
    throw new Error("getFile is only available on native platforms");
  }

  return await Chooser.getFile(mimeTypes);
}
